import moment from 'moment-timezone'
import Vue2Filters from 'vue2-filters'

const number = v => (v || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
const decimal = v => (v || 0).toFixed(2);

const date = (value, opt = 'YYYY.MM.DD') => (value && moment(value).format(opt) || '-');
const datetime = (value, opt = 'YYYY.MM.DD HH:mm:ss') => (value && moment(value).format(opt) || '-');
const utcdatetime = (value, opt = 'YYYY.MM.DD HH:mm:ss') => (value && moment(value).utc().format(opt) || '-');
const sdate = (value) => value && moment(value).format(moment().startOf('d').isSame(moment(value).startOf('d')) ? 'HH:mm' : 'YYYY.MM.DD') || '-';
const utcsdate = (value) => value && moment(value).utc().format(moment().startOf('d').isSame(moment(value).startOf('d')) ? 'HH:mm' : 'YYYY.MM.DD') || '-';
const dollar = (v) => { return v ? (new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD'})).format(v) : '-' };
const numbering = v => { return (v).toString().padStart(9, "ㅤ")};

var Filter = {
  install: function(Vue) {
    Vue.use(Vue2Filters);
    Vue.filter('decimal', decimal);
    Vue.filter('number', number);
    Vue.filter('dollar', dollar)
    Vue.filter('date', date);
    Vue.filter('datetime', datetime); // 테스트 필요
    Vue.filter('sdate', sdate); // 테스트 필요
    Vue.filter('utcdatetime', utcdatetime);
    Vue.filter('utcsdate', utcsdate);
    Vue.filter('numbering', numbering);
  }
}

export default Filter;

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(Filter);
}
